<div class="dialog-header">
    <div class="dialog-header-title">
        {{ 'game.dialog.callTime.title' | translate }}
    </div>
    <div class="dialog-header-close-button">
        <button (click)="close()">
            <svg-icon src="assets/img/icons/dialog-close.svg"
                [stretch]="true"
                [applyClass]="true"
                class="dialog-header-close-button-icon" />
        </button>
    </div>
</div>
<ng-container  *ngIf="callTimeCountdownTimer$ | async as timer; else callTimeNotActivated">
    <div class="dialog-content app-game-call-time-dialog-content">
        <div class="app-game-call-time-dialog-text">
            {{ 'game.dialog.callTime.message' | translate }}
        </div>
        <div class="app-game-call-time-dialog-timer">
            {{timer?.minutes}}m : {{timer?.seconds}}s
        </div>
    </div>
    <div class="dialog-footer">
        <div class="app-game-call-time-dialog-footer">
            <button class="app-game-call-time-dialog-footer-button-ok" appButton (click)="close()">{{ 'game.dialog.callTime.okButton' | translate }}</button>
        </div>
    </div>  
</ng-container>
<ng-template #callTimeNotActivated>
    <div class="dialog-content app-game-call-time-dialog-content">
        <div class="app-game-call-time-dialog-text">
            {{ 'game.dialog.callTime.message' | translate }}
        </div>
    </div>  
    <div class="dialog-footer">
        <div class="app-game-call-time-dialog-footer">
            <button class="app-game-call-time-dialog-footer-button-accept success" appButton
                (click)="startCallTime()">{{ 'game.dialog.callTime.startCallTime' | translate }}</button>

            <button class="app-game-call-time-dialog-footer-button-cancel" appButton (click)="close()">{{ 'game.dialog.callTime.cancelButton' | translate }}</button>
        </div>
    </div>
</ng-template>


